import React from 'react'
import GoogleSignIn from '../../../login/components/GoogleSignIn'

import Button from '../../../common/components/Button';
import { CrumplePopSignupContext } from '../../contexts/CrumplePopSignupContext';
import { axiosPost } from '../../../common/js/axios-utility';
import CountryStateSelectNew from '../../../common/components/CountryStateSelectNew';
import { errorToast } from '../../../common/js/toast-utility';

export default function CrumplePopSignup({onComplete}) {
    const [migrationState, setMigrationState] = React.useContext(CrumplePopSignupContext);
    const form = React.useRef(null);

    const handleBack = () => {};

    const handleSubmit = async event => {
        event.preventDefault();
        setMigrationState({...migrationState, processing: true});
        try{
            const user = migrationState.cpopUser;
            const grecapToken = await grecaptcha.execute('6LeQ58wUAAAAAOO3JdYg_gxcIMwN9GXg8cWkz1i_', { action: 'signin' })

            if (form.current.password.value != form.current.confirmPassword.value){
                errorToast('Passwords do not match.');
                setMigrationState({...migrationState, processing: false});
                return;
            };

            const payload = {
                "email" : user.email,
                "firstName" : user.firstName,
                "lastName" : user.lastName,
                "company" : null,
                "password" : form.current.password.value,
                "passwordConfirm": form.current.confirmPassword.value,
                "country" : user.address ? user.address.country : form.current.country.value,
                "state" : '',
                "oauthType" : null,
                "oauthId" : null,
                "isCpop" : true,
                "isTest" : false
            }
            payload['g-recaptcha-response'] = grecapToken;
            if (user.address){
                payload.state = user.address.state;
            }
            else if (form.current.state != null){
                payload.state = form.current.state.value;
            }
            
            const signUpResult = await axiosPost('/cpop/signup', payload);
            onComplete(signUpResult.data);
        }
        catch(err){
            console.error(err);
            errorToast('Failed to create a Boris FX account. Please review your information and try again');
            setMigrationState({...migrationState, processing: false});
        }
    }

  return (
    <div className='cpop-signup-container'>
      <form onSubmit={handleSubmit} ref={form}>
        {!migrationState.cpopUser.address && (
            <CountryStateSelectNew singleRow />
        )}
        <div className='form-row'>
            <div className='form-field'>
                <label>Create Boris FX password</label>
                <input name="password" type="password" autoComplete='password' required />
                <span className='field-footer'>
                    At least one uppercase letter, one number,
                    and one special character.
                </span>
            </div>
            <div className='form-field'>
                <label>Confirm Password</label>
                <input name="confirmPassword" type="password" autoComplete='password' required />
            </div>
        </div>
        <div className='cpop-signup-buttons text-right'>
            <Button 
                className='btn-new back-btn' 
                label="Back" 
                onClick={handleBack} />
            <Button 
                className='btn-new' 
                label="Create Boris FX Account" 
                processingLabel="Please Wait..."
                submit />
        </div>
      </form>
    </div>
  )
}
